export default __webpack_public_path__ + "static/media/olho.eb13b38a.svg";